import Vue from 'vue';

import ConfigurationPlugin from './configuration';
import ScreenPlugin from './screen';
import I18nPlugin from './i18n';
import VueCompositionAPI from '@/lib/vue-composition-api.js';

export const installPlugins = () => {
    Vue.use(ConfigurationPlugin);
    Vue.use(ScreenPlugin);
    Vue.use(I18nPlugin);
    Vue.use(VueCompositionAPI);
};
